// The "… Get in touch ›" footer line on Settings cards — the reference's
// Practice profile footer, reused by Delivery addresses while adding or editing
// an address there isn't built.
import { Link } from "react-router-dom";

import { Icon } from "@/design-system";

export default function SettingsHelpLine({ children, className = "" }) {
  return (
    <p
      className={`flex items-baseline gap-[var(--space-4)] text-sm text-ink-3 my-0 leading-[1.6] ${className}`}
    >
      <span>{children}</span>
      <Link
        to="/contact"
        className="v2link ml-auto text-blue-700 font-semibold whitespace-nowrap hover:text-blue-800"
      >
        Get in touch
        <Icon name="chevron_right" size={15} className="chev" />
      </Link>
    </p>
  );
}
